import { render } from "./RettungEintragen.vue?vue&type=template&id=6792da5c"
import script from "./RettungEintragen.vue?vue&type=script&lang=js"
export * from "./RettungEintragen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__